import { render, staticRenderFns } from "./FormDeliveryDate.vue?vue&type=template&id=9e11db88"
import script from "./FormDeliveryDate.vue?vue&type=script&lang=js"
export * from "./FormDeliveryDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormDeliveryDate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e11db88')) {
      api.createRecord('9e11db88', component.options)
    } else {
      api.reload('9e11db88', component.options)
    }
    module.hot.accept("./FormDeliveryDate.vue?vue&type=template&id=9e11db88", function () {
      api.rerender('9e11db88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormDeliveryDate.vue"
export default component.exports